import React, { useState } from "react";
import SuccessPopup from "./SuccessPopup"; // путь подкорректируй под свою структуру
// если путь другой, например, `../components/SuccessPopup`, поправь его

const TestimonialsPage = () => {
  const [formData, setFormData] = useState({ name: "", feedback: "" });
  const [feedbacks] = useState([
    {
      name: "Алексей",
      feedback:
        "Отличное качество продукции! Заказал арматуру, все пришло в срок и без повреждений. Рекомендую всем!",
    },
    {
      name: "Екатерина",
      feedback:
        "Очень довольна покупкой! Приятно удивлена качеством обслуживания. Все очень быстро и удобно!",
    },
    {
      name: "Иван",
      feedback:
        "Не ожидал, что доставка будет настолько быстрой. Плюс ко всему, товар полностью соответствует описанию. Спасибо!",
    },
    {
      name: "Марина",
      feedback:
        "Отличное качество арматуры, а главное - адекватная цена. Буду заказывать еще!",
    },
  ]);

  const [successMessage, setSuccessMessage] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "/api/submit-testimonial/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setFormData({ name: "", feedback: "" });
        setSuccessMessage(true);
        setTimeout(() => setSuccessMessage(false), 3000);
      } else {
        const data = await response.json();
        console.error("Ошибка при отправке отзыва", data);
      }
    } catch (err) {
      console.error("Ошибка запроса", err);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8 relative min-h-screen">
      <h1 className="text-3xl font-semibold mb-6 text-center">
        Отзывы наших клиентов
      </h1>

      <div className="space-y-8">
        {feedbacks.map((testimonial, index) => (
          <div key={index} className="bg-white p-6 shadow-md rounded-lg">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center text-white text-xl font-semibold mr-4">
                {testimonial.name ? testimonial.name[0] : ""}
              </div>
              <div>
                <h3 className="font-semibold text-lg">
                  {testimonial.name || "Без имени"}
                </h3>
              </div>
            </div>
            <p className="text-lg text-gray-700">
              {testimonial.feedback || "Отзыв не доступен"}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <h3 className="text-xl font-semibold mb-4">Оставьте свой отзыв</h3>
        <form onSubmit={handleSubmit} className="max-w-md mx-auto space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Ваше имя"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
          <textarea
            name="feedback"
            placeholder="Ваш отзыв"
            value={formData.feedback}
            onChange={handleChange}
            rows="4"
            required
            className="w-full p-2 border border-gray-300 rounded-lg"
          />
          <button
            type="submit"
            className="w-full bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition duration-300"
          >
            Оставить отзыв
          </button>
        </form>
      </div>

      {/* Компонент успешного уведомления */}
      {successMessage && (
        <SuccessPopup message="Спасибо за ваш отзыв!" onClose={() => setSuccessMessage(false)} />
      )}
    </div>
  );
};

export default TestimonialsPage;
